import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const formatValue = (value, name) => {
    if (name && (
        name.toLowerCase().includes('clientes') || 
        name.toLowerCase().includes('linhas') || 
        name.toLowerCase().includes('valor') || 
        name.toLowerCase().includes('acessos') ||
        name.toLowerCase().includes('erros') ||
        name.toLowerCase().includes('em dia') ||
        name.toLowerCase().includes('inadimplente')
    )) {
        return value.toLocaleString('pt-BR');
    }
    if (typeof value === 'number') {
        return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    return value;
};

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <Box 
                p={3} 
                bg="rgba(0,0,0,0.4)" 
                borderRadius="md" 
                border="1px solid" 
                borderColor="secondary" 
                backdropFilter="blur(8px)" 
                boxShadow="0 0 10px rgba(52, 211, 103, 0.5)"
                zIndex={99} 
            >
                <Text color="secondary" fontWeight="bold" mb={1}>{label}</Text>
                {payload.map((p, index) => (
                    <Text key={index} color={p.color || 'white'} fontSize="sm">
                        {p.name}: <strong>{formatValue(p.value, p.name)}</strong>
                    </Text>
                ))}
            </Box>
        );
    }
    return null;
};

export default CustomTooltip;